<breadcrumb endText="Automatic Roster Import" [navigations]="breadcrumbNavs" />
<div class="m-8">
  <div class="flex justify-between items-center">
    <h1 class="font-medium text-xl">
      Automatic Roster Import
    </h1>
    <clear-button (click)="create()" [faIcon]="faPlus" text="Create" />
  </div>
  <hr />
  <table class="w-full text-left mt-10">
    <thead>
      <tr>
        <th class="pl-2">Host</th>
        <th>Status</th>
        <th>User Name</th>
        <th>Creation Date</th>
        <th>Last Update Date</th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      @for (configItem of configList; track configItem; let i = $index) {
        <tr [ngClass]="i % 2 === 0? '': 'bg-gray-100'">
          <td class="rounded-l-[8px] pl-2 py-2">{{configItem.host}}</td>
          <td>{{configItem.active == true ? 'Active' : 'Inactive'}}</td>
          <td>{{configItem.username}}</td>
          <td>{{configItem.createdate}}</td>
          <td>{{configItem.last_updated}}</td>
          <td class="rounded-r-[8px]">
            <button (click)="edit(configItem.rostersource_id)" class="group hover:bg-gray-100 rounded-lg px-2 py-1 border border-gray-200">
              <fa-icon [icon]="faPencilAlt" class="p-0.5 text-gray-500" />
              Edit
            </button>
          </td>
        </tr>
      }
    </tbody>
  </table>
</div>
